"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApiUrl = void 0;
const apiConfig_1 = require("./apiConfig");
const getApiUrl = (path) => {
    if (/^https?:\/\//i.test(path)) {
        return path;
    }
    const base = (0, apiConfig_1.getApiBaseUrl)();
    const route = path.startsWith('/') ? path : `/${path}`;
    return `${base}${route}`;
};
exports.getApiUrl = getApiUrl;
